import type { Combatant } from './simulation'

export function fightDevelopmentScore(timer:number,impactSerial:number,player:Combatant,enemy:Combatant){
 const elapsed=Math.max(0,99-timer)
 const playerLoss=1-player.health/Math.max(1,player.maxHealth)
 const enemyLoss=1-enemy.health/Math.max(1,enemy.maxHealth)
 return impactSerial*1.35+elapsed*.12+(playerLoss+enemyLoss)*9
}

export function structuralPulseFor(score:number){
 if(score>=38)return 36
 if(score>=30)return 28
 if(score>=22)return 18
 if(score>=14)return 10
 return 0
}

export function shouldDevastateStage(score:number,status:string){
 if(status==='match-over')return score>=22
 if(status==='round-over')return score>=38
 return false
}

export function devastationRatio(score:number){
 return Math.max(0,Math.min(1,(score-8)/30))
}
